import { NgModule } from '@angular/core';
import { PrincipalConfigurationService } from './services';
import { UserRootStoreModule } from './store/user-root-store.module';

@NgModule({
  imports: [UserRootStoreModule],
  providers: [PrincipalConfigurationService],
})
export class UserRootModule {}
